import React, { useEffect, useState } from "react";
import { Container } from "./style";
import InstallIcon from "../../../../../projectSpecificComponents/svgIcons/install";

export default () => {
  const [showInstall, setShowInstall] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    const handleBeforeInstallPrompt = event => {
      // Prevent the default prompt
      event.preventDefault();

      // Show the install button
      setShowInstall(true);

      // Stash the event so it can be triggered later
      setDeferredPrompt(event);
    };

    // Add event listener for beforeinstallprompt
    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      // Remove event listener when component is unmounted
      window.removeEventListener(
        "beforeinstallprompt",
        handleBeforeInstallPrompt
      );
    };
  }, []);
  const installApp = () => {
    // Trigger the deferred prompt
    console.log(deferredPrompt);
    if (deferredPrompt) {
      deferredPrompt.prompt();

      // Wait for the user to respond to the prompt
      deferredPrompt.userChoice.then(choiceResult => {
        if (choiceResult.outcome === "accepted") {
          console.log("User accepted the installation");
        } else {
          console.log("User declined the installation");
        }

        // Clear the deferred prompt
        setDeferredPrompt(null);

        // Hide the install button
        setShowInstall(false);
      });
    }
  };

  return (
    <Container>
      {showInstall && (
        <i
          className="left-side-icon icon"
          onClick={installApp}
          title="نصب بر روی کامپیوتر شما"
        >
          <InstallIcon size={26} />
        </i>
      )}
    </Container>
  );
};
